export default __webpack_public_path__ + "static/title-illustration-2363957c509e3aed0f2393ecee543535.svg";